<template>
  <div class="contact-us">
    <ContactUsForm/>
  </div>
</template>

<script>

import ContactUsForm from '@/components/ContactUsForm.vue'

export default {
  components: {
    ContactUsForm
  },
  props: {}
}
</script>

<style scoped lang="scss">
</style>






